/**
 * Field types generated from `src/api/graphql/schema.graphql`.
 *
 * Do not edit. Run `bun run graphql:types` after changing the SDL; CI fails
 * the `GraphQL schema` check when this file and the SDL disagree.
 *
 * One entry per object type, naming each field whose type is an enum or
 * another object type. `decodePayload` walks a payload against this: an enum
 * field is translated back to its domain value, an object field is descended
 * into, and every other field is left exactly as it arrived.
 *
 * @module platform/graphql-enum-fields.generated
 */

/** Enum-typed and object-typed fields, by the type they are selected from. */
export const FIELD_TYPES: Record<string, Record<string, string>> = {
  NarrativeUpdate: {},
  RealtimeConnection: {},
  Programme: {
    workflowState: "WorkflowState",
    deliveryStatus: "DeliveryStatus",
    archivedFrom: "WorkflowState",
    visibilityState: "VisibilityState",
    modules: "Module",
    plos: "PLO",
    versions: "ProgrammeVersion",
    electiveDefinitions: "ElectiveDefinition",
    ploToMimlos: "PloTraceability",
    responsibilities: "ProgrammeResponsibilityConnection",
    moduleOwners: "ModuleOwnerConnection",
    exports: "ExportConnection",
    governanceRevisions: "GovernanceRevision",
    governanceFindings: "GovernanceFinding",
    amendmentProposals: "AmendmentProposal",
    reviewRounds: "ReviewRoundConnection",
    relationships: "ProgrammeRelationship",
  },
  GovernanceRevision: {},
  CurriculumRevision: {
    kind: "CurriculumRevisionKind",
  },
  ChangeCaseTeamSnapshot: {
    responsibilities: "ProgrammeResponsibility",
    moduleOwnership: "ModuleOwner",
  },
  CurriculumChangeCase: {
    kind: "CurriculumChangeCaseKind",
    classification: "AmendmentClassification",
    status: "CurriculumChangeCaseStatus",
    carriedTeam: "ChangeCaseTeamSnapshot",
    identityImpactDecision: "IdentityImpactDecision",
  },
  GovernanceFinding: {
    severity: "FindingSeverity",
    status: "FindingStatus",
  },
  AmendmentProposal: {
    classification: "AmendmentClassification",
    status: "AmendmentStatus",
  },
  PloTraceability: {},
  Module: {
    mimlos: "MIMLO",
    casOriginalMimlos: "MIMLO",
    casDeviationNotes: "CasDeviationNote",
    assessments: "ModuleAssessment",
    readingList: "ReadingListItem",
    owner: "ModuleOwner",
  },
  CasDeviationNote: {},
  MIMLO: {},
  ModuleAssessment: {
    participatingModules: "CrossModuleAssessmentParticipation",
  },
  CrossModuleAssessmentParticipation: {},
  ReadingListItem: {},
  PLO: {
    standardMappings: "PloStandardMapping",
  },
  PloStandardMapping: {},
  ProgrammeVersion: {
    stages: "Stage",
  },
  Stage: {
    modules: "StageModule",
    electiveChoiceSlots: "StageElectiveChoiceSlot",
  },
  StageModule: {},
  StageElectiveChoiceSlot: {},
  ElectiveDefinition: {
    groups: "ElectiveGroup",
  },
  ElectiveGroup: {},
  Tenant: {
    users: "UserConnection",
  },
  User: {
    accountRole: "AccountRole",
  },
  ApprovalDecision: {
    readinessOverrideBlockers: "ReadinessBlockerSnapshot",
  },
  ApproveProgrammeResult: {
    programme: "Programme",
    decision: "ApprovalDecision",
    approvedRevision: "GovernanceRevision",
    curriculumRevision: "CurriculumRevision",
    applicability: "RevisionApplicability",
    readinessOverrideDecision: "ReadinessOverrideDecision",
  },
  OpenRevalidationResult: {
    changeCase: "CurriculumChangeCase",
  },
  OpenAmendmentResult: {
    changeCase: "CurriculumChangeCase",
  },
  CreateReplacementProgrammeResult: {
    changeCase: "CurriculumChangeCase",
    programme: "Programme",
    relationship: "ProgrammeRelationship",
  },
  ApproveChangeCaseResult: {
    changeCase: "CurriculumChangeCase",
    decision: "ApprovalDecision",
    approvedRevision: "GovernanceRevision",
    curriculumRevision: "CurriculumRevision",
    applicability: "RevisionApplicability",
  },
  ReviewChangeCaseResult: {
    changeCase: "CurriculumChangeCase",
    review: "ProgrammeReviewOutcome",
  },
  SubmitChangeCaseForReviewResult: {
    changeCase: "CurriculumChangeCase",
    approvalCandidate: "ApprovalCandidate",
    reviewRound: "ReviewRound",
    submittedRevision: "GovernanceRevision",
  },
  ProgrammeIdentityFieldChange: {},
  IdentityImpactDecision: {
    changedFields: "ProgrammeIdentityFieldChange",
  },
  PortfolioProgrammeRevision: {
    lifecycleStatus: "RevisionLifecycleStatus",
    publicationStatus: "PublicationStatus",
    latestPublication: "PortfolioPublicationSummary",
  },
  PortfolioPublicationSummary: {},
  PublicCurriculumApiAccess: {},
  PublicationValidationIssue: {
    severity: "PublicationIssueSeverity",
  },
  ProgrammePublicationPreview: {
    issues: "PublicationValidationIssue",
  },
  CurriculumPublication: {},
  TenantEntitlementDecision: {},
  RevisionLifecycleEntry: {
    status: "RevisionLifecycleStatus",
  },
  PublicationStatus: {
    status: "PublicationStatusKind",
  },
  RevisionPublicationEntry: {
    status: "PublicationStatusKind",
  },
  ProgrammeRelationship: {},
  ChangeCaseWorkspace: {
    changeCase: "CurriculumChangeCase",
    programme: "Programme",
  },
  ConfirmChangeCaseTeamResult: {
    changeCase: "CurriculumChangeCase",
  },
  FinalExportResult: {
    programme: "Programme",
    snapshot: "Snapshot",
    exportRecord: "Export",
  },
  CompleteReviewActionResult: {
    programme: "Programme",
    review: "ProgrammeReviewOutcome",
  },
  RevisionFieldChange: {},
  RevisionImpactReport: {},
  ApplicableRevision: {
    revision: "GovernanceRevision",
    applicability: "RevisionApplicability",
  },
  ChangeCaseRevisionComparison: {
    changes: "RevisionFieldChange",
    impact: "RevisionImpactReport",
    identityChanges: "ProgrammeIdentityFieldChange",
  },
  RevisionComparison: {
    changes: "RevisionFieldChange",
    impact: "RevisionImpactReport",
    identityChanges: "ProgrammeIdentityFieldChange",
  },
  ReleaseEditLeasePayload: {},
  RevokeProgrammeResponsibilityPayload: {},
  RevokeModuleOwnerPayload: {},
  NotificationFeedItem: {
    role: "ResponsibilityKind",
  },
  NotificationFeed: {
    items: "NotificationFeedItem",
  },
  SessionExchangeResult: {},
  LogoutResult: {},
  ImpersonationResult: {},
  StopImpersonationResult: {},
  MarkNotificationReadPayload: {},
  MarkAllNotificationsReadPayload: {},
  ProgrammeReviewRoundReviewerStatus: {},
  ProgrammeReviewRoundTimeline: {
    round: "ReviewRound",
    outcomes: "ProgrammeReviewOutcome",
    requiredReviewerStatuses: "ProgrammeReviewRoundReviewerStatus",
  },
  WorkflowStateCount: {
    state: "WorkflowState",
  },
  DeliveryStatusCount: {
    status: "DeliveryStatus",
  },
  PortfolioSummary: {
    workflowCounts: "WorkflowStateCount",
    deliveryCounts: "DeliveryStatusCount",
    recentAuditEvents: "AuditEvent",
  },
  TenantConfigurationGap: {},
  PlatformTenantSummary: {},
  PlatformAdministrativeAuditEvent: {},
  PlatformAdminOverview: {
    tenants: "PlatformTenantSummary",
    configurationGaps: "TenantConfigurationGap",
    recentAdministrativeEvents: "PlatformAdministrativeAuditEvent",
  },
  ReadinessBlockerTarget: {},
  ReadinessBlocker: {
    target: "ReadinessBlockerTarget",
  },
  ReadinessResult: {
    blockers: "ReadinessBlocker",
  },
  ReadinessBlockerSnapshot: {},
  ReadinessOverrideDecision: {
    blockerSnapshot: "ReadinessBlockerSnapshot",
  },
  WorkflowTransitionResult: {
    programme: "Programme",
    readinessOverrideDecision: "ReadinessOverrideDecision",
  },
  ApprovalCandidate: {
    readiness: "ReadinessResult",
    readinessOverrideBlockers: "ReadinessBlockerSnapshot",
  },
  RevisionApplicability: {},
  ProgrammeReviewOutcome: {},
  FinalSignOff: {},
  Snapshot: {},
  ProgrammeGovernanceSummary: {
    readiness: "ReadinessResult",
    approvalCandidates: "ApprovalCandidate",
    governanceRevisions: "GovernanceRevision",
    curriculumRevisions: "CurriculumRevision",
    curriculumChangeCases: "CurriculumChangeCase",
    programmeRelationships: "ProgrammeRelationship",
    revisionLifecycle: "RevisionLifecycleEntry",
    revisionPublication: "RevisionPublicationEntry",
    governanceFindings: "GovernanceFinding",
    amendmentProposals: "AmendmentProposal",
    revisionApplicability: "RevisionApplicability",
    reviewRounds: "ReviewRound",
    blockingFindings: "ProgrammeReviewOutcome",
    signOffs: "FinalSignOff",
    snapshots: "Snapshot",
    exports: "Export",
    changeCaseReadiness: "ChangeCaseReadiness",
    actions: "ProgrammeActionDecision",
  },
  Refusal: {
    code: "RefusalCode",
  },
  ProgrammeActionDecision: {
    action: "ProgrammeAction",
    refusal: "Refusal",
  },
  ChangeCaseReadiness: {
    readiness: "ReadinessResult",
  },
  ModuleReview: {},
  ModuleSubmissionWarning: {},
  ModuleSubmission: {
    warnings: "ModuleSubmissionWarning",
  },
  ModuleWorkspaceVersionContext: {},
  IncomingCrossModuleAssessment: {},
  ModuleWorkspace: {
    workflowState: "WorkflowState",
    visibilityState: "VisibilityState",
    versions: "ModuleWorkspaceVersionContext",
    module: "Module",
    incomingCrossModuleAssessments: "IncomingCrossModuleAssessment",
    plos: "PLO",
    ploToMimlos: "PloTraceability",
    moduleReview: "ModuleReview",
    submissionWarnings: "ModuleSubmissionWarning",
    latestSubmission: "ModuleSubmission",
  },
  AssignedModule: {
    workflowState: "WorkflowState",
  },
  TenantOnboardingSummary: {},
  EditLease: {},
  ProviderContact: {},
  ExportMetadataEntry: {},
  ProviderSettings: {
    validationContact: "ProviderContact",
    exportMetadata: "ExportMetadataEntry",
  },
  TenantProviderSettings: {
    settings: "ProviderSettings",
  },
  TenantAccessPolicy: {},
  SessionUser: {},
  TenantContext: {},
  TenantMembership: {
    accountRole: "AccountRole",
  },
  AuthorizationSubject: {
    responsibilities: "ProgrammeResponsibility",
  },
  SessionContext: {
    tenant: "Tenant",
    tenantContext: "TenantContext",
    user: "SessionUser",
    membership: "TenantMembership",
    subject: "AuthorizationSubject",
  },
  ProgrammeResponsibility: {
    responsibility: "ResponsibilityKind",
    user: "User",
  },
  ModuleOwner: {
    user: "User",
  },
  Export: {
    format: "ExportFormat",
    workflowState: "WorkflowState",
    visibilityState: "VisibilityState",
  },
  AuditEvent: {},
  ReviewRound: {},
  PageInfo: {},
  ProgrammeEdge: {
    node: "Programme",
  },
  ProgrammeConnection: {
    edges: "ProgrammeEdge",
    pageInfo: "PageInfo",
  },
  TenantEdge: {
    node: "Tenant",
  },
  TenantConnection: {
    edges: "TenantEdge",
    pageInfo: "PageInfo",
  },
  UserEdge: {
    node: "User",
  },
  UserConnection: {
    edges: "UserEdge",
    pageInfo: "PageInfo",
  },
  AuditEventEdge: {
    node: "AuditEvent",
  },
  AuditEventConnection: {
    edges: "AuditEventEdge",
    pageInfo: "PageInfo",
  },
  ExportEdge: {
    node: "Export",
  },
  ExportConnection: {
    edges: "ExportEdge",
    pageInfo: "PageInfo",
  },
  ProgrammeResponsibilityEdge: {
    node: "ProgrammeResponsibility",
  },
  ProgrammeResponsibilityConnection: {
    edges: "ProgrammeResponsibilityEdge",
    pageInfo: "PageInfo",
  },
  ModuleOwnerEdge: {
    node: "ModuleOwner",
  },
  ModuleOwnerConnection: {
    edges: "ModuleOwnerEdge",
    pageInfo: "PageInfo",
  },
  AssignedModuleEdge: {
    node: "AssignedModule",
  },
  AssignedModuleConnection: {
    edges: "AssignedModuleEdge",
    pageInfo: "PageInfo",
  },
  ReviewRoundEdge: {
    node: "ReviewRound",
  },
  ReviewRoundConnection: {
    edges: "ReviewRoundEdge",
    pageInfo: "PageInfo",
  },
  TenantOnboardingEdge: {
    node: "TenantOnboardingSummary",
  },
  TenantOnboardingConnection: {
    edges: "TenantOnboardingEdge",
    pageInfo: "PageInfo",
  },
  NotificationEdge: {
    node: "NotificationFeedItem",
  },
  NotificationConnection: {
    edges: "NotificationEdge",
    pageInfo: "PageInfo",
  },
  Query: {
    getCurrentSession: "SessionContext",
    getTenantProviderSettings: "TenantProviderSettings",
    getTenantAccessPolicy: "TenantAccessPolicy",
    getPortfolioSummary: "PortfolioSummary",
    getPlatformAdminOverview: "PlatformAdminOverview",
    getTenantPortfolio: "PortfolioProgrammeRevision",
    getPublicCurriculumApiAccess: "PublicCurriculumApiAccess",
    previewProgrammePublication: "ProgrammePublicationPreview",
    getProgrammeGovernance: "ProgrammeGovernanceSummary",
    loadChangeCaseWorkspace: "ChangeCaseWorkspace",
    compareChangeCaseRevision: "ChangeCaseRevisionComparison",
    getModuleWorkspace: "ModuleWorkspace",
    getNotificationFeed: "NotificationFeed",
    listTenants: "Tenant",
    listTenantOnboarding: "TenantOnboardingSummary",
    listTenantUsers: "User",
    listProgrammeReviewRounds: "ProgrammeReviewRoundTimeline",
    listAccessibleProgrammes: "Programme",
    listAssignedModules: "AssignedModule",
    listProgrammeResponsibilities: "ProgrammeResponsibility",
    listModuleOwners: "ModuleOwner",
    listAuditEvents: "AuditEvent",
    listExports: "Export",
    loadProgramme: "Programme",
    narrativeUpdates: "NarrativeUpdate",
    getProgrammeSummary: "Programme",
    resolveRevisionApplicability: "ApplicableRevision",
    compareGovernanceRevisions: "RevisionComparison",
    programme: "Programme",
    programmes: "ProgrammeConnection",
    tenants: "TenantConnection",
    users: "UserConnection",
    auditEvents: "AuditEventConnection",
    exports: "ExportConnection",
    responsibilities: "ProgrammeResponsibilityConnection",
    moduleOwners: "ModuleOwnerConnection",
    assignedModules: "AssignedModuleConnection",
    reviewRounds: "ReviewRoundConnection",
    tenantOnboarding: "TenantOnboardingConnection",
    notifications: "NotificationConnection",
  },
  Mutation: {
    createTenant: "TenantOnboardingSummary",
    reissueTenantInvitation: "TenantOnboardingSummary",
    resendTenantInvitation: "User",
    inviteTenantUser: "User",
    changeTenantUserRole: "User",
    changeTenantUserCapabilities: "User",
    changeTenantUserStatus: "User",
    changeTenantUserEmail: "User",
    updateTenantProviderSettings: "TenantProviderSettings",
    updateTenantAccessPolicy: "TenantAccessPolicy",
    createProgramme: "Programme",
    saveProgramme: "Programme",
    acquireEditLease: "EditLease",
    renewEditLease: "EditLease",
    releaseEditLease: "ReleaseEditLeasePayload",
    negotiateRealtimeConnection: "RealtimeConnection",
    saveModuleWorkspace: "ModuleWorkspace",
    createModule: "ModuleWorkspace",
    submitModuleForReview: "ModuleWorkspace",
    reviewModule: "ModuleWorkspace",
    assignProgrammeResponsibility: "ProgrammeResponsibility",
    assignModuleOwner: "ModuleOwner",
    revokeProgrammeResponsibility: "RevokeProgrammeResponsibilityPayload",
    revokeModuleOwner: "RevokeModuleOwnerPayload",
    transitionWorkflow: "Programme",
    transitionWorkflowWithOverride: "WorkflowTransitionResult",
    approveProgramme: "ApproveProgrammeResult",
    openRevalidation: "OpenRevalidationResult",
    openAmendment: "OpenAmendmentResult",
    confirmChangeCaseTeam: "ConfirmChangeCaseTeamResult",
    withdrawChangeCase: "CurriculumChangeCase",
    saveChangeCaseWorkspace: "ChangeCaseWorkspace",
    submitChangeCaseForReview: "SubmitChangeCaseForReviewResult",
    reviewChangeCase: "ReviewChangeCaseResult",
    markChangeCaseReviewed: "CurriculumChangeCase",
    publishProgramme: "CurriculumPublication",
    withdrawProgrammePublication: "CurriculumPublication",
    setTenantPublicCurriculumApiEntitlement: "TenantEntitlementDecision",
    createReplacementProgramme: "CreateReplacementProgrammeResult",
    approveChangeCase: "ApproveChangeCaseResult",
    decideChangeCaseIdentityImpact: "CurriculumChangeCase",
    createGovernanceFinding: "GovernanceFinding",
    resolveGovernanceFinding: "GovernanceFinding",
    createRevisionApplicability: "RevisionApplicability",
    setProgrammeDeliveryStatus: "Programme",
    setProgrammeEndOfLife: "Programme",
    recordReviewOutcome: "ProgrammeReviewOutcome",
    completeReviewAction: "CompleteReviewActionResult",
    recordFinalSignOff: "FinalSignOff",
    recordExportPreview: "Export",
    exportFinal: "FinalExportResult",
    reviseFromSnapshot: "Programme",
    markNotificationRead: "MarkNotificationReadPayload",
    updateMyPreferences: "SessionUser",
    markAllNotificationsRead: "MarkAllNotificationsReadPayload",
    exchangeSession: "SessionExchangeResult",
    logoutSession: "LogoutResult",
    impersonateUser: "ImpersonationResult",
    stopImpersonation: "StopImpersonationResult",
  },
};
